<template>
  <aw-spring :desktop-size="10">
    <aw-breadcrumb-version2 :class="$style.breadcrumb" />
    <aw-cms-white-card
      mobile-negative-margin
      :class="$style.card"
    >
      <template #head>
        <lv-heading
          level="1"
          tag="h1"
          version2
        >
          {{ $awt('aw.pages.prize_draw.title') }}
        </lv-heading>
      </template>
      <template #default>
        <ul :class="[$style.priceDrawList, 'ulReset']">
          <aw-prize-game-card
            v-for="item in data"
            :key="item.id"
            :content-data="item"
            :tag="'li'"
          />
        </ul>
      </template>
    </aw-cms-white-card>
  </aw-spring>
</template>

<script setup lang="ts">
  import { onMounted, ref } from 'vue';
  import { useNuxtApp } from 'nuxt/app';
  import AwCmsWhiteCard from '~~/common/components/AwCmsWhiteCard.vue';
  import { LvHeading } from '~~/common/components/loginet-vue-shop/index';
  import otqs from '~~/common/utils/objectToQueryString';
  import { AW_AX_CACHE_GLOBAL } from '~~/common/plugins/axios/awAxCache';
  import { useBreadcrumbStore } from '~~/common/stores/breadcrumb.js';
  import AwBreadcrumbVersion2 from '~~/common/components/Common/AwBreadcrumbVersion2.vue';
  import AwSpring from '~~/common/components/AwSpring.vue';
  import AwPrizeGameCard from '~~/shop/app/components/Page/PriceDraw/AwPrizeGameCard.vue';
  import type { ResponseDataOpStrict, Schema } from '~~/common/types/api';
  import { defineI18nRoute } from '#i18n';

  type PrizeDrawResponse = ResponseDataOpStrict<'get_tag_group_collection'>;

  defineOptions({
    name: 'PriceDrawPage',
  });

  // eslint-disable-next-line no-undef
  definePageMeta({
    layout: 'full-width',
  });

  false && /*#__PURE__*/ defineI18nRoute({
    paths: {
      en: '/prize-game',
      hu: '/nyeremenyjatekok',
    },
  });

  const { $api, $awt } = useNuxtApp();

  const isLoading = ref(false);
  const data = ref<Schema<'TagGroupListModel'>[]>([]);

  async function fetchData () {
    isLoading.value = true;
    const params = {
      // highlighted: false,
      page: 1,
      limit: 100,
    };
    const result = await $api.$get<PrizeDrawResponse>(`cms/tag-groups/prize_draw${otqs(params)}`, { awAxCache: AW_AX_CACHE_GLOBAL });
    data.value = result.contentVersions;
    isLoading.value = false;
  }

  onMounted(async () => {
    await fetchData();

    const breadcrumbStore = useBreadcrumbStore();

    breadcrumbStore.setBreadcrumbs([
      {
        token: $awt('aw.common.category.home'),
        to: '/',
        disabled: false,
      },
      {
        token: $awt('aw.pages.prize_draw.title'),
        to: 'prize-game',
        disabled: true,
      },
    ]);
  });
</script>

<style module lang="scss" rel="stylesheet/scss">
.card {
  margin-bottom: 20px;
  @include tablet(min) {
    margin-bottom: 60px;
  }
}

.breadcrumb {
  margin-bottom: 20px;
  @include tablet(min) {
    margin-bottom: 40px;
  }
}

.priceDrawList {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  width: 100%;
  margin-bottom: 20px;
  @include tablet(min) {
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
    margin-bottom: 40px;
  }
  @include desktop-small(min) {
    gap: 32px;
  }
  @include desktop-medium(min) {
    gap: 40px;
  }
}
</style>
